// extracted by mini-css-extract-plugin
export var container = "NodeHighlightedServiceCard-module--container--e962d";
export var image = "NodeHighlightedServiceCard-module--image--c1218";
export var image__container = "NodeHighlightedServiceCard-module--image__container--fb883";
export var link = "NodeHighlightedServiceCard-module--link--1ff0c";